<template>
    <div>
        <HeaderPage></HeaderPage>
        <div class="content">
            <SlideShow></SlideShow>
        </div>
        <div class="contact">
            <h2>联系我们</h2>
            <p>公司网址: http://szdmetc.com</p>
            <div style="display:flex">
                <p>联系电话：</p>
                <p>
                   400-829-2006
                </p>
            </div>
            <div style="display:flex">
                <p>邮箱：</p>
                <p>
                    25048129@qq.com 
                </p>
            </div>
            <p>公司地址： 深圳市龙岗区南湾街道上李社区平吉大道平朗路9号</p>
        </div>
        <FooterPage></FooterPage>
    </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage.vue';
import SlideShow from '@/components/SlideShow.vue';
import FooterPage from '@/components/FooterPage.vue';

export default {
    name: 'ContactUs',
    components: {
        HeaderPage,
        SlideShow,
        FooterPage
    },
}
</script>

<style scoped>
.content {
  width: 80%;
  margin: auto;
}
.contact {
    width: 60%;
    margin: auto;
    /* background-color: aquamarine; */
    text-align: left;
    line-height: 50px;
    font-size: 18px;
    font-weight: 500;
}
.contact h2 {
    text-align: center;
}
p {
    margin: 0;
}
</style>